// import React, { useState, useEffect, useRef } from 'react';
// import {
//   TextField,
//   Grid,
//   Typography,
//   Container,
//   IconButton,
//   Button,
// } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
// import style from '../../Tools/Style.js';
// import ModalClientes from '../../GestionDeClientes/ModalClientes.js';
// import { obtenerClientes } from '../../../actions/ClientesAction.js';
// import { useStateValue } from '../../../contexto/store.js';
// import { nuevaSugerencia } from '../../../actions/SugerenciasAction.js';
// import { RegistrarAccion } from '../../../actions/AuditoriaAction.js';
// import Editor from 'react-draft-wysiwyg';

// const BuzonDesugerencias = () => {
//   const mounted = useRef(true);
//   const [Datacl, setDatacl] = useState([]);
//   const [datosCargados, setDatosCargados] = useState(false);
//   //eslint-disable-next-line
//   const [{ openSnackbar, sesionUsuario }, dispatch] = useStateValue();
//   const [clientes, setClientes] = useState('');
//   const [modalBuscar, setModalBuscar] = useState(false);
//   const [contenido, setContenido] = useState('');
//   const [editorValue, setEditorValue] = useState(
//     Editor.createValueFromString(contenido, 'html')
//   );
//   const handleChange = (value) => {
//     setEditorValue(value);
//     setContenido(value.toString('html'));
//   };
//   const [sugerencia, setSugerencia] = useState({
//     cliente_id: '',
//   });
//   const ingresarValoresMemoria = (e) => {
//     const { name, value } = e.target;
//     setSugerencia((anterior) => ({
//       ...anterior,
//       [name]: value,
//     }));
//   };
//   const seleccionarCliente = (cliente) => {
//     setClientes(cliente.nombre + ' ' + cliente.apellido);
//     setSugerencia({
//       contenido: sugerencia.contenido,
//       cliente_id: cliente.clientE_Id,
//     });
//     setModalBuscar(false);
//   };
//   const abrirModal = () => {
//     setModalBuscar(true);
//   };
//   const cerrarModal = () => {
//     setModalBuscar(false);
//   };
//   const enviarSugerencia = () => {
//     if (contenido !== '') {
//       let objeto = {};
//       if (sugerencia.cliente_id !== '' && contenido !== '') {
//         objeto = {
//           contenido: contenido,
//           clienteId: sugerencia.cliente_id,
//         };
//       } else if (sugerencia.cliente_id === '' && contenido !== '') {
//         objeto = {
//           contenido: contenido,
//         };
//       }
//       nuevaSugerencia(objeto).then((response) => {
//         if (response.status === 200) {
//           dispatch({
//             type: 'OPEN_SNACKBAR',
//             openMensaje: {
//               open: true,
//               mensaje: 'Se Guardo la sugerencia del cliente',
//             },
//           });
//           setSugerencia({
//             contenido: '',
//             cliente_id: '',
//           });
//           setClientes('');
//           setContenido('');
//           setEditorValue(Editor.createValueFromString(contenido, 'html'));
//         } else {
//           dispatch({
//             type: 'OPEN_SNACKBAR',
//             openMensaje: {
//               open: true,
//               mensaje: 'Errores al intentar Enviar Sugerencia',
//             },
//           });
//         }
//       });
//       let objetoAudi = {
//         usuario: sesionUsuario.usuario.nombrecompleto,
//         accion: 'Registro',
//         panel: 'Gestion de Clientes',
//         tabla: 'SUGERENCIAS',
//         filaafectada: 'NUEVO REGISTRO',
//         UsuarioId: sesionUsuario.usuario.id,
//       };
//       RegistrarAccion(objetoAudi);
//     } else {
//       dispatch({
//         type: 'OPEN_SNACKBAR',
//         openMensaje: {
//           open: true,
//           mensaje:
//             'Debe llenar al menos el campo Sugerencia para poder Enviar ',
//         },
//       });
//     }
//   };
//   useEffect(() => {
//     if (mounted.current) {
//       obtenerClientes().then((response) => {
//         if (response.status === 200) {
//           setDatacl(response.data);
//           setDatosCargados(true);
//         }
//       });
//     }
//     return function cleanup() {
//       mounted.current = false;
//     };
//   }, []);
//   return (
//     <Container component="main" maxWidth="md" justify="center">
//       <div style={style.paper}>
//         <br></br>
//         <br></br>
//         <Typography component="h1" variant="h6">
//           Reporte sobre Cliente
//         </Typography>
//         <br></br>
//         <br></br>
//         <form style={style.form}>
//           <Grid container spacing={1}>
//             <IconButton
//               onClick={abrirModal}
//               style={style.iconbutton}
//               aria-label="buscar"
//             >
//               <SearchIcon />
//               <Typography>Relacionar a un Cliente</Typography>
//             </IconButton>
//             <TextField
//               multiline
//               name="CLIENTE"
//               value={clientes}
//               fullWidth
//               onChange={ingresarValoresMemoria}
//               variant="outlined"
//               label="CLIENTE"
//             />
//             <br />
//             <br />
//             <br />
//             <br />
            
//               <Editor
//                 placeholder='Escribir aqui...'
//                 value={editorValue}
//                 onChange={handleChange}
//                 type="string"
//                 rootStyle={{ width: '100%'}}
//                 editorStyle={{height:200}}
//               />
            
//           </Grid>
//           <br />
//           <Button
//             variant="contained"
//             color="primary"
//             style={style.submit}
//             onClick={enviarSugerencia}
//           >
//             Enviar Reporte
//           </Button>
//           <Grid container direction="row" justify="center" alignItems="center">
//             <ModalClientes
//               data={Datacl}
//               open={modalBuscar}
//               handleClose={cerrarModal}
//               seleccionarCliente={seleccionarCliente}
//               datosCargados={datosCargados}
//             />
//           </Grid>
//         </form>
//       </div>
//     </Container>
//   );
// };
// export default BuzonDesugerencias;


import React, { useState, useEffect, useRef } from 'react';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {
  TextField,
  Typography,
  Container,
  IconButton,
  Button,
  Paper,
  Box,
  Grid,
} from '@mui/material';
import {
  Search as SearchIcon,
  Lightbulb as LightbulbIcon,
  Send as SendIcon,
  AccountCircle as AccountCircleIcon,
  Description as DescriptionIcon,
} from '@mui/icons-material';
import ModalClientes from '../../GestionDeClientes/ModalClientes.js';
import { obtenerClientes } from '../../../actions/ClientesAction.js';
import { useStateValue } from '../../../contexto/store.js';
import { nuevaSugerencia } from '../../../actions/SugerenciasAction.js';
import { RegistrarAccion } from '../../../actions/AuditoriaAction.js';
import { Editor } from 'react-draft-wysiwyg';
const BuzonDesugerencias = () => {
  const mounted = useRef(true);
  const [Datacl, setDatacl] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false);
  //eslint-disable-next-line
  const [{ openSnackbar, sesionUsuario }, dispatch] = useStateValue();
  const [clientes, setClientes] = useState('');
  const [modalBuscar, setModalBuscar] = useState(false);
  const [contenido, setContenido] = useState('');
  
  // 1. Initialize the editor state with an empty state
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const handleChange = (newEditorState) => {
    setEditorState(newEditorState);
    // Convert the editor content to HTML to store it
    setContenido(newEditorState.getCurrentContent().getPlainText()); // Use getPlainText() or convert to HTML
  };

  const [sugerencia, setSugerencia] = useState({
    cliente_id: '',
  });

  const seleccionarCliente = (cliente) => {
    const apellido = cliente.apellido ? ' ' + cliente.apellido : '';
    setClientes(cliente.nombre + apellido);
    setSugerencia({
        contenido: sugerencia.contenido,
        cliente_id: cliente.clientE_Id,
    });
    setModalBuscar(false);
};

  const abrirModal = () => {
    setModalBuscar(true);
  };

  const cerrarModal = () => {
    setModalBuscar(false);
  };

  const enviarSugerencia = () => {
    if (contenido !== '') {
      let objeto = {};
      if (sugerencia.cliente_id !== '' && contenido !== '') {
        objeto = {
          contenido: contenido,
          clienteId: sugerencia.cliente_id,
        };
      } else if (sugerencia.cliente_id === '' && contenido !== '') {
        objeto = {
          contenido: contenido,
        };
      }
      nuevaSugerencia(objeto).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Se Guardo la sugerencia del cliente',
            },
          });
          setSugerencia({
            contenido: '',
            cliente_id: '',
          });
          setClientes('');
          setContenido('');
          setEditorState(EditorState.createEmpty());
        } else {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Errores al intentar Enviar Sugerencia',
            },
          });
        }
      });
      let objetoAudi = {
        usuario: sesionUsuario.usuario.nombrecompleto,
        accion: 'Registro',
        panel: 'Gestion de Clientes',
        tabla: 'SUGERENCIAS',
        filaafectada: 'NUEVO REGISTRO',
        UsuarioId: sesionUsuario.usuario.id,
      };
      RegistrarAccion(objetoAudi);
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Debe llenar al menos el campo Sugerencia para poder Enviar ',
        },
      });
    }
  };

  useEffect(() => {
    if (mounted.current) {
      obtenerClientes().then((response) => {
        if (response.status === 200) {
          setDatacl(response.data);
          setDatosCargados(true);
        }
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, []);
  
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <LightbulbIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Nueva Sugerencia
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              Registra sugerencias o comentarios de clientes
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Formulario */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Información de la Sugerencia
        </Typography>

        <Grid container spacing={3}>
          {/* Cliente relacionado */}
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                mb: 2,
              }}
            >
              <IconButton
                onClick={abrirModal}
                color="primary"
                sx={{
                  backgroundColor: 'action.hover',
                  '&:hover': {
                    backgroundColor: 'action.selected',
                  },
                }}
              >
                <SearchIcon />
              </IconButton>
              <Typography variant="body2" color="text.secondary">
                Relacionar esta sugerencia con un cliente (opcional)
              </Typography>
            </Box>
            <TextField
              name="CLIENTE"
              value={clientes}
              fullWidth
              variant="outlined"
              label="Cliente Relacionado"
              disabled
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <AccountCircleIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          {/* Editor de contenido */}
          <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              sx={{ mb: 1, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <DescriptionIcon sx={{ fontSize: 20, color: 'action.active' }} />
              Contenido de la Sugerencia *
            </Typography>
            <Box
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                overflow: 'hidden',
              }}
            >
              <Editor
                placeholder="Escribir aquí..."
                editorState={editorState}
                onEditorStateChange={handleChange}
                wrapperStyle={{ width: '100%' }}
                editorStyle={{ minHeight: 250, padding: '0 16px' }}
                toolbar={{
                  options: ['inline', 'list', 'textAlign', 'history'],
                  inline: {
                    options: ['bold', 'italic', 'underline'],
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Botón de acción */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Button
          variant="contained"
          size="large"
          startIcon={<SendIcon />}
          onClick={enviarSugerencia}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 6,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          Enviar Sugerencia
        </Button>
      </Box>

      {/* Modal de búsqueda de clientes */}
      <ModalClientes
        data={Datacl}
        open={modalBuscar}
        handleClose={cerrarModal}
        seleccionarCliente={seleccionarCliente}
        datosCargados={datosCargados}
      />
    </Container>
  );
};

export default BuzonDesugerencias;